'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TabArea from '../TabArea/TabArea';

import s from './TabbedTextPanel.module.scss';

const TabbedTextPanel = ({ tabs = [] }) => {
    const [activeTab, setActiveTab] = useState(tabs[0]?.id || '');

    const activeTabObj = tabs.find((tab) => tab.id === activeTab);
    const activeContent = activeTabObj?.text;

    return (
        <div className={s.Root}>
            <div className={s.Container}>
                <TabArea
                    items={tabs.map((tab) => ({
                        title: tab.title,
                        buttonId: tab.id,
                        isActive: tab.id === activeTab,
                    }))}
                    isLink={false}
                    activeItem={activeTab}
                    setActiveItem={setActiveTab}
                    className={s.Tabs}
                />

                <div className={s.Content}>
                    {activeContent && (
                        <div className={s.TextWrapper}>
                            <div className={s.Description}>
                                <h2 className={s.Title}>
                                    {activeContent.title}
                                </h2>
                                {activeContent.description && (
                                    <p className={s.DescriptionText}>
                                        {activeContent.description}
                                    </p>
                                )}
                            </div>
                            <div className={s.TextContent}>
                                {typeof activeContent.content === 'string' ? (
                                    <div
                                        className={s.Text}
                                        dangerouslySetInnerHTML={{
                                            __html: activeContent.content,
                                        }}
                                    />
                                ) : (
                                    <div className={s.CustomContent}>
                                        {activeContent.content}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

TabbedTextPanel.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            text: PropTypes.shape({
                title: PropTypes.string.isRequired,
                description: PropTypes.string,
                content: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
                    .isRequired,
                open: PropTypes.bool,
                modifier: PropTypes.string,
                isSmallText: PropTypes.bool,
                showThreeRows: PropTypes.bool,
            }).isRequired,
        })
    ).isRequired,
};

export default TabbedTextPanel;
